import React, { FCX } from 'react';
import styled from '@emotion/styled';

const Component: FCX = ({ className, children }) => <div {...{ className }}>{children}</div>;

const StyledComponent = styled(Component)`
  h1 {
    font-size: 275%;
  }
  h2 {
    font-size: 220%;
  }
  h3 {
    font-size: 110%;
  }
  h5 {
    font-size: 185%;
  }
`;

export default StyledComponent;
